import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import MediaQuery from 'react-responsive';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.css';
import BasicButton from '../../../BasicButton';
import BasicSelect from '../../../BasicSelect';

const LanguageSelect = props => {
  const {
    name,
    removable = false,
    disabled,
    isValid,
    values: { language: initLanguage, level: initLevel },
    languageOptions,
    levelOptions,
    controlFunc,
    touchFunc,
    hiddenLanguages,
    handleRemove,
    index,
  } = props;

  const [language, setLanguage] = useState(initLanguage);
  const [level, setLevel] = useState(initLevel);

  const selectOnChangeLanguage = selectedOption => {
    setLanguage(selectedOption);
  };
  const selectOnChangeLevel = selectedOption => {
    setLevel(selectedOption);
  };

  useEffect(() => {
    if (
      (language || level) &&
      (!isEqual(language, initLanguage) || !isEqual(level, initLevel))
    ) {
      controlFunc(index, {
        language: language,
        level: level,
      });
    }
  }, [language, level]);

  const handleOnBlur = () => {
    if (
      touchFunc &&
      language &&
      level &&
      (!isEqual(language, initLanguage) || !isEqual(level, initLevel))
    ) {
      touchFunc(index, true, true);
    }
  };

  const handleFilterOption = (option, string) => {
    const hide =
      hiddenLanguages && hiddenLanguages.length > 0
        ? hiddenLanguages.indexOf(option.value) === -1
        : true;

    return string && hide
      ? option.label.toLowerCase().startsWith(string.toLowerCase())
      : hide;
  };

  const onRemove = () => {
    return handleRemove(index);
  };

  return (
    <div className="language-select">
      <div className="language-select__row">
        <div className="language-select__element">
          <BasicSelect
            disabled={disabled}
            name={`${name}_language`}
            value={language}
            isValid={!!language || isValid}
            required={false}
            filterOption={handleFilterOption}
            isDisabled={disabled}
            placeholder="Select from list"
            options={languageOptions}
            controlFunc={selectOnChangeLanguage}
            touchFunc={handleOnBlur}
          />
        </div>
        <div className="language-select__element">
          <BasicSelect
            name={`${name}_level`}
            isDisabled={disabled}
            isSearchable={false}
            value={level}
            isValid={!!level || isValid}
            placeholder="Select from list"
            options={levelOptions}
            controlFunc={selectOnChangeLevel}
            touchFunc={handleOnBlur}
          />
        </div>
        <div className="language-select__remove-btn">
          {removable && (
            <>
              <MediaQuery query="(min-width: 481px)">
                <button className="language-select__button" onClick={onRemove}>
                  <FontAwesomeIcon icon={faTrashAlt} color="#f40" size="lg" />
                </button>
              </MediaQuery>

              <MediaQuery query="(max-width: 480px)">
                <div className="language-select__button">
                  <BasicButton
                    btnWidth={150}
                    btnHeight={35}
                    btnFontSize="0.8571rem"
                    btnFontWeight={600}
                    btnText="Remove"
                    btnArrow={false}
                    controlFunc={onRemove}
                  />
                </div>
              </MediaQuery>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

LanguageSelect.propTypes = {
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isValid: PropTypes.bool,
  levelOptions: PropTypes.array,
  values: PropTypes.object,
  controlFunc: PropTypes.func.isRequired,
  languageOptions: PropTypes.array,
  hiddenLanguages: PropTypes.array,
  touchFunc: PropTypes.func,
};

export default LanguageSelect;
